import L from 'leaflet';

// FE-27 (2026-09-19) — el recorrido se dibuja en verde y con pines de gota
// Inicio/Fin, como la app de referencia (antes: azul, y píldoras "🏁 INICIO" /
// "📍 FINAL" estilo `TripDetailModal`, que conserva su propio azul: ese es el
// recorrido de UN viaje, y este es el histórico por rango).
//
// El verde de la línea (#22C55E) y el del pin de inicio (#16A34A) son dos
// tonos a propósito: el pin lleva borde blanco y un verde más oscuro para no
// perderse sobre la propia línea; el vehículo sigue amarillo (más abajo).
export const ROUTE_LINE_COLOR = '#22C55E';

function createRoutePinIcon(color: string, label: string) {
  return L.divIcon({
    className: '',
    html: `<div style="position:relative;width:44px;height:55px;filter:drop-shadow(0 3px 4px rgba(0,0,0,0.5));">
      <svg width="44" height="55" viewBox="0 0 38 48" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 46C19 46 3.5 29.5 3.5 18.5C3.5 9.9 10.4 3 19 3s15.5 6.9 15.5 15.5C34.5 29.5 19 46 19 46z" fill="${color}" stroke="#FFFFFF" stroke-width="2.4"/>
      </svg>
      <span style="position:absolute;top:15px;left:0;right:0;text-align:center;font-size:8px;line-height:12px;font-weight:800;letter-spacing:0.2px;color:#FFFFFF;">${label}</span>
    </div>`,
    iconSize: [44, 55],
    iconAnchor: [22, 53],
    popupAnchor: [0, -50],
  });
}

export const routeStartIcon = createRoutePinIcon('#16A34A', 'INICIO');
export const routeEndIcon = createRoutePinIcon('#EF4444', 'FIN');

// FE-26 — marcador de la reproducción animada: una silueta de camión vista
// desde arriba (cabina + caja), no un triángulo — pedido del dueño
// (2026-09-19), "una imagen del vehículo en vez de la flecha". Se regenera
// cada frame porque el rumbo (bearing) cambia; los de arriba son estáticos.
// La cabina queda arriba del ícono sin rotar (0°), así que `bearing=0` =
// "apunta al norte" coincide con la convención del resto del mapa.
//
// Amarillo (#FACC15), no el verde de la polyline (ROUTE_LINE_COLOR): con el mismo
// color, el marcador del vehículo se perdía visualmente dentro de la propia
// línea del recorrido — pedido del dueño (2026-09-18) para distinguir "dónde
// está el vehículo ahora" de "por dónde pasó".
export function createPlaybackVehicleIcon(bearingDeg: number) {
  return L.divIcon({
    className: '',
    html: `<div style="width:28px;height:28px;transform:rotate(${bearingDeg}deg);display:flex;align-items:center;justify-content:center;filter:drop-shadow(0 2px 4px rgba(0,0,0,0.7)) drop-shadow(0 0 5px rgba(250,204,21,0.9));">
      <svg width="22" height="26" viewBox="0 0 22 26" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="11" width="16" height="14" rx="2" fill="#FACC15" stroke="#1F2937" stroke-width="1.4"/>
        <rect x="5" y="1" width="12" height="11" rx="2.5" fill="#FACC15" stroke="#1F2937" stroke-width="1.4"/>
        <rect x="7" y="3.5" width="8" height="5" rx="1" fill="#1F2937" opacity="0.85"/>
      </svg>
    </div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

// FE-26 — parada del recorrido (agrupada por `detectStops`, `utils/vehicleHistory.ts`).
export const routeStopIcon = L.divIcon({
  className: '',
  html: `<div style="width:24px;height:24px;border-radius:50%;background:#F59E0B;border:2.5px solid #FFFFFF;box-shadow:0 2px 8px rgba(245,158,11,0.7);display:flex;align-items:center;justify-content:center;color:#FFFFFF;font-size:11px;font-weight:800;">P</div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
